<!-- Add/Edit Vehicle Repair Modal -->
<div class="modal fade" id="kt_modal_add_edit_vehicle_repair" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header" id="kt_modal_add_edit_vehicle_repair_header">
        <h2 class="fw-bold">{{ isEditMode ? 'Edit' : 'Add' }} Vehicle Repair</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body px-5 my-7">
        <form [formGroup]="vehicleRepairForm" (ngSubmit)="onSubmit()" id="kt_modal_add_edit_vehicle_repair_form">

          <!-- Stock (Vehicle) Field - Full Width -->
          <div class="fv-row mb-7">
            <label class="required fw-semibold fs-6 mb-2">Stock</label>
            <div class="position-relative">
              <input
                type="text"
                class="form-control form-control-solid mb-3 mb-lg-0"
                formControlName="vehicle_name"
                (input)="onVehicleSearchInput($event)"
                (focus)="onVehicleInputFocus()"
                (blur)="onVehicleInputBlur()"
                placeholder="Search for vehicle..."
                autocomplete="off"
                [disabled]="isVehicleSelectionDisabled"
                [readonly]="isVehicleSelectionDisabled" />

              <!-- Vehicle Search Dropdown -->
              <div class="dropdown-menu show w-100 mh-300px overflow-auto"
                   *ngIf="showVehicleDropdown && (vehicleSearchResults.length > 0 || isVehicleSearching) && !isVehicleSelectionDisabled"
                   style="position: absolute; top: 100%; left: 0; z-index: 1050;">

                <!-- Loading State -->
                <div class="dropdown-item text-center py-3" *ngIf="isVehicleSearching">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Searching vehicles...
                </div>

                <!-- Vehicle Results -->
                <a class="dropdown-item cursor-pointer py-3"
                   *ngFor="let vehicle of vehicleSearchResults"
                   (click)="selectVehicle(vehicle)">
                  <div class="d-flex align-items-center">
                    <div class="symbol symbol-40px me-3">
                        <img [src]="getVehicleImageUrl(vehicle)" alt="Vehicle" />
                    </div>
                    <div class="d-flex flex-column">
                      <span class="fw-bold text-gray-800">{{ vehicle.car_no || vehicle.name || 'N/A' }}</span>
                      <span class="text-muted fs-7">
                        {{ vehicle.company_name }} {{ vehicle.name }} {{ vehicle.year }}
                      </span>
                    </div>
                  </div>
                </a>

                <!-- No Results -->
                <div class="dropdown-item text-center py-3 text-muted"
                     *ngIf="!isVehicleSearching && vehicleSearchResults.length === 0">
                  No vehicles found
                </div>
              </div>
            </div>

            <!-- Validation Error -->
            <div *ngIf="vehicle_name?.invalid && (vehicle_name?.dirty || vehicle_name?.touched)"
                 class="fv-plugins-message-container">
              <div class="fv-help-block">
                <span role="alert" *ngIf="vehicle_name?.errors?.['required']">Stock is required</span>
              </div>
            </div>
          </div>

          <!-- Row 1: Company and Cost -->
          <div class="row mb-7">
            <div class="col-md-6">
              <div class="fv-row">
                <label class="fw-semibold fs-6 mb-2">Company</label>
                <input
                  type="text"
                  class="form-control form-control-solid mb-3 mb-lg-0"
                  formControlName="company"
                  placeholder="Enter company name" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="fv-row">
                <label class="fw-semibold fs-6 mb-2">Cost</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control form-control-solid"
                    formControlName="cost"
                    placeholder="Enter cost amount"
                    min="0"
                    step="0.01" />
                  <span class="input-group-text">JPY</span>
                </div>

                <!-- Validation Error -->
                <div *ngIf="cost?.invalid && (cost?.dirty || cost?.touched)"
                     class="fv-plugins-message-container">
                  <div class="fv-help-block">
                    <span role="alert" *ngIf="cost?.errors?.['pattern']">Please enter a valid amount</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Row 2: Order Date and Complete Date -->
          <div class="row mb-7">
            <div class="col-md-6">
              <div class="fv-row">
                <label class="fw-semibold fs-6 mb-2">Order Date</label>
                <input
                  type="date"
                  class="form-control form-control-solid mb-3 mb-lg-0"
                  formControlName="order_date" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="fv-row">
                <label class="fw-semibold fs-6 mb-2">Complete Date</label>
                <input
                  type="date"
                  class="form-control form-control-solid mb-3 mb-lg-0"
                  formControlName="complete_date" />
              </div>
            </div>
          </div>

          <!-- Status Field - Full Width -->
          <div class="fv-row mb-7">
            <label class="fw-semibold fs-6 mb-2">Status</label>
            <select class="form-select form-select-solid" formControlName="status">
              <option *ngFor="let option of statusOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Problems Field -->
          <div class="fv-row mb-7">
            <label class="fw-semibold fs-6 mb-2">Problems</label>
            <textarea
              class="form-control form-control-solid"
              formControlName="problems"
              rows="3"
              placeholder="Describe any problems or issues..."></textarea>
          </div>

          <!-- Note Field -->
          <div class="fv-row mb-7">
            <label class="fw-semibold fs-6 mb-2">Note</label>
            <textarea
              class="form-control form-control-solid"
              formControlName="note"
              rows="3"
              placeholder="Add any additional notes..."></textarea>
          </div>

        </form>
      </div>

      <div class="modal-footer flex-center">
        <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="isLoading || vehicleRepairForm.invalid"
          (click)="onSubmit()">
          <span class="indicator-label">{{ isEditMode ? 'Update' : 'Save' }}</span>
          <span class="indicator-progress" *ngIf="isLoading">
            Please wait...
            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
